import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import map from 'lodash/fp/map';

import { styled } from '@prose-ui/legacy';

import Spacer from 'Components/Spacer';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import LoadingScene from 'Scenes/LoadingScene';

import { customSkincare as customSkincareData } from 'assets/content/home';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import * as productsSelectors from 'dux/products/selectors';
import { useFetchProductsList } from 'dux/products/hooks';

import HeroSection from './CustomSkincare/CustomSkincareHero';
import MobileCustomSlider from './CustomSlider/MobileSlider';
import ProductCard from './ProductCard';

const SectionContainer = styled.div`
  width: 100%;
  position: relative;
  background: ${props => props.theme.palette.common.beige.darker};
  ${props => props.theme.breakpoints.up('md')} {
    border-top: 1px solid;
    padding-bottom: ${props => props.theme.spacing.s144}px;
    padding-right: ${props => props.theme.spacing.s40}px;
    padding-left: ${props => props.theme.spacing.s40}px;
  }
`;

const ProductCardsContainer = styled.div`
  display: grid;
  justify-content: center;
  grid-gap: ${props => props.theme.spacing.s40}px;
  margin: 0 auto;
  ${props => props.theme.breakpoints.up('xs')} {
    grid-template-columns: repeat(3, 1fr);
  }
  ${props => props.theme.breakpoints.up('md')} {
    grid-template-columns: repeat(3, 1fr);
    padding-top: ${props => props.theme.spacing.s56}px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 1200px;
  }
`;

const CustomSkincare = ({ fetchedProducts, heroContent }) => {
  const { isLoaded } = useFetchProductsList();
  const { isDesktop } = useResponsiveVariant();

  const cards = map(
    product => (
      <ProductCard
        key={product.label}
        dataClick={`${product.slug}-card`}
        dataFrom="skincare-grid"
        isNew
        product={product}
      />
    ),
    fetchedProducts
  );

  if (!isLoaded) {
    return <LoadingScene />;
  }
  return (
    <SectionContainer>
      <HeroSection content={heroContent} />
      {isDesktop && <Spacer size={144} />}
      {isDesktop ? (
        <ProductCardsContainer>{cards}</ProductCardsContainer>
      ) : (
        <MobileCustomSlider fetchedProducts={fetchedProducts} />
      )}
    </SectionContainer>
  );
};

CustomSkincare.defaultProps = {
  heroContent: customSkincareData,
};

CustomSkincare.propTypes = {
  heroContent: PropTypes.shape({}),
  fetchedProducts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      capacity: PropTypes.string,
      priceWithSubscription: PropTypes.number,
      bgLabelledPicture: srcOrNextImageProp,
      productPageUrl: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default connect(state => ({
  heroContent: customSkincareData,
  fetchedProducts: productsSelectors.getFetchedSkincareProductsMergedWithLocalProductsList(state),
}))(CustomSkincare);
